import { GetFieldForFilterAndSort } from '../Util/Field';

const TaskStateCollectionFields = [
	GetFieldForFilterAndSort(
		"NameLower",
		"Name",
		"FieldType_Text",
	),
	GetFieldForFilterAndSort(
		"Index",
		"Position",
		"FieldType_Number",
	),
];

export default TaskStateCollectionFields;